import * as yup from "yup";
import { ZIP_CODE_REGEX } from "../utils/ValidationRules";

export default yup.string().matches(ZIP_CODE_REGEX, {
	message: "ZIP_CODE_NOT_VALID",
	excludeEmptyString: true,
});
